<template>
  <div class="wh100">
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <table class="table">
          <tr>
            <td class="header" style="width: 15%; text-align: center">
              <p>所属行业:</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].IndustryName }}
            </td>
            <td class="header" style="width: 15%; text-align: center">
              <p>所属区域:</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].AreaName }}
            </td>
            <td class="header" style="width: 15%; text-align: center">
              污染源名称:
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].PollSrcName }}
            </td>
          </tr>

          <tr>
            <td class="header" style="width: 15%; text-align: center">
              <p>是否在线:</p>
            </td>
            <td style="width: 35%; text-align: left">
              <span v-if="tableData[0].IsOnline == 0">
                离线
              </span>
              <span v-if="tableData[0].IsOnline == 1">
                在线
              </span>
            </td>
            <td class="header" style="width: 15%; text-align: center">
              <p>企业运行状态：</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].EntRunStateName }}
            </td>
            <td class="header" style="width: 15%; text-align: center">
              企业规模：
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].EnterpriseScaleName }}
            </td>
          </tr>
          <tr>
            <td class="header" style="width: 15%; text-align: center">
              <p>所属源类型：</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].SrcTypeName }}
            </td>
            <td class="header" style="width: 15%; text-align: center">
              <p>登记注册类型</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].EntRegisterName }}
            </td>
            <td class="header" style="width: 15%; text-align: center">
              <p>经纬度：</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].GDStationLocationX }} ,
              {{ tableData[0].GDStationLocationY }}
            </td>
          </tr>
          <tr>
            <td class="header" style="width: 15%; text-align: center">
              法人:
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].LegalPerson }}
            </td>
            <td class="header" style="width: 15%; text-align: center">
              <p>联系人:</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].Linkman }}
            </td>
            <td class="header" style="width: 15%; text-align: center">
              <p>联系电话:</p>
            </td>
            <td style="width: 35%; text-align: left">
              {{ tableData[0].LinkmanPhone }}
            </td>
          </tr>

          <tr>
            <td
              class="header"
              style="width: 15%; text-align: center"
              rowspan="5"
            >
              <p>所在地址：</p>
            </td>
            <td style="width: 35%; text-align: left" colspan="5" rowspan="5">
              {{ tableData[0].Address }}
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <!-- <el-tab-pane label="文档信息">文档信息</el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
export default {
  props: {
    tableData: [],
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
/deep/.table {
  width: 100%;
  line-height: 15px;
  color: black;
  overflow-y: scroll;
  font-size: 15px;
  table-layout: fixed;
  border-collapse: collapse;
  tr {
    border: 1px solid rgba(172, 172, 172, 0.37);
    td {
      box-sizing: border-box;
      padding: 0 10px;
      border: 1px solid rgb(197, 197, 197);
    }
  }
}
.header {
  background-color: rgb(238, 238, 238);
}
</style>
